<template>
  <v-card class="showcase-interaction surface lighten-1">
    <div class="window-controls">
      <v-spacer />
      <v-icon small>mdi-window-minimize</v-icon>
      <v-icon small>mdi-window-restore</v-icon>
      <v-icon small>mdi-window-close</v-icon>
    </div>
    <div class="header">
      <div class="basic-info">
        <div class="bp-info">TECHNICAL SUPPORT - 100</div>
        <div class="name">Nikola Tesla</div>
        <v-row class="chips">
          <v-chip v-show="!noChips" class="ml-2 mr-2" color="accent" small>
            Technical Support
          </v-chip>
          <v-chip v-show="!noChips" class="mr-2" color="accent" small>
            Application Support
          </v-chip>
        </v-row>
      </div>
      <v-avatar size="60" :color="$vuetify.theme.dark ? 'var(--v-accent-base)' : 'var(--v-surface-base)'">
        NT
      </v-avatar>
    </div>
    <div class="toolbar">
      <div class="links">
        Links:
        <a>Support Docs</a>
        <a>Mng.Product</a>
      </div>
      <div class="actions">
        <v-spacer />
        <v-tooltip v-for="(item, index) in toolbarOptions" :key="index" bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="controls" icon small v-on="on">
              <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ item.label }}</span>
        </v-tooltip>
        <div>
          <v-btn class="primary-action" color="primary" small raised>
            <v-icon small left>{{ primaryAction.icon }}</v-icon>
            {{ primaryAction.label }}
          </v-btn>
        </div>
      </div>
    </div>
    <slot></slot>
    <div class="footer"></div>
  </v-card>
</template>

<script>
export default {
  name: 'EcsShowcaseInteraction',

  components: {},

  props: {
    toolbarOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    primaryAction: {
      type: Object,
      default: () => {
        return {};
      }
    },
    noChips: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.showcase-interaction {
  width: 480px;
  margin: 0 auto;
  padding-bottom: 32px;
}

.showcase-interaction .window-controls {
  display: flex;
  padding: 6px;
}

.showcase-interaction .header {
  display: grid;
  grid-template-columns: auto 72px;
}

.showcase-interaction .header .v-avatar {
  font-size: 22px;
}

.showcase-interaction .header .basic-info {
  display: grid;
  padding: 0 12px;
  height: 88px;
}

.showcase-interaction .header .basic-info .chips {
  height: 22px;
}

.showcase-interaction .header .basic-info .chips .v-chip {
  height: 22px;
}

.showcase-interaction .toolbar {
  display: grid;
  grid-template-columns: auto 220px;
  padding: 4px 12px;
}

.actions {
  display: flex;
}

.controls,
.controls .v-icon {
  font-size: 16px !important;
  margin: 0 !important;
}

.primary-action {
  font-size: 12px !important;
  margin: 0 0 0 12px !important;
}

.controls:not(:first-child) {
  margin-left: 8px;
}

.showcase-interaction .links {
  font-size: 10px;
  height: 30px;
  line-height: 30px;
}

.showcase-interaction .header .name {
  font-size: 18pt;
}

.showcase-interaction .header .bp-info {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.75;
}
</style>
